(() => {
  if (customElements.get('tiles-slider')) {
    return;
  }

  class TilesSlider extends HTMLElement {
    constructor() {
      super();

      this.slider = null;
      this.controlsWrapper = this.closest('section').querySelector('[data-controls-wrapper]');
      this.cardsSize = this.dataset.cardsSize || 'default';
      this.shouldDestroyOnDesktop = this.hasAttribute('data-destroy');
      this.breakpoints = { desktop: 990 };
      this._rafPending = false;
      this.scrollable = false;
      this.trackWidth = 0;
      this.thumbWidth = 0;
    }

    connectedCallback() {
      const section = this.closest('section');
      this.progressThumb = section ? section.querySelector('[data-tiles-progress-thumb]') : null;
      this.progressTrack = section ? section.querySelector('[data-tiles-progress]') : null;

      this.measureProgress = this.measureProgress.bind(this);
      this.positionProgress = this.positionProgress.bind(this);

      this.initSlider();
      this.toggleSliderHandler();
      window.addEventListener('resize', debounce(this.toggleSliderHandler.bind(this), 500));
      window.addEventListener('resize', debounce(this.measureProgress, 200));
      window.addEventListener('load', this.measureProgress);
    }

    initSlider() {
      const sliderList = this.querySelector('.links-with-image__slider');

      if (!sliderList) return;

      const useCssMode = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);

      const sizeCardSettings = {
        default: {
          slidesPerView: 1.2,
          spaceBetween: 16,
          breakpoints: {
            [this.breakpoints.desktop]: {
              slidesPerView: 'auto',
              spaceBetween: 24,
            },
          }
        },
        small: {
          slidesPerView: 1.5,
          spaceBetween: 16,
          breakpoints: {
            [this.breakpoints.desktop]: {
              slidesPerView: 'auto',
              spaceBetween: 24,
            },
          }
        },
      };

      const self = this;

      const mainSettings = {
        navigation: {
          nextEl: '.links-with-image__arrow-next',
          prevEl: '.links-with-image__arrow-prev',
        },
        speed: 350,
        grabCursor: !useCssMode,
        resistanceRatio: 0.72,
        observer: true,
        observeParents: true,
        updateOnImagesReady: true,
        // Touch: native CSS scroll momentum (buttery, like iOS / BoConcept).
        // Mouse: Swiper free-mode so click-drag still works.
        cssMode: useCssMode,
        freeMode: useCssMode ? false : {
          enabled: true,
          sticky: false,
          momentum: true,
          momentumRatio: 1,
          momentumVelocityRatio: 1,
          momentumBounce: true,
          momentumBounceRatio: 1,
        },
        freeModeMomentum: true,
        freeModeMomentumRatio: 1,
        freeModeMomentumVelocityRatio: 1,
        freeModeSticky: false,
        on: {
          afterInit() { self.measureProgress(this); self.positionProgress(this); },
          imagesReady() { self.measureProgress(this); self.positionProgress(this); },
          resize() { self.measureProgress(this); self.positionProgress(this); },
          progress() { self.schedulePosition(this); },
          setTranslate() { self.schedulePosition(this); },
          setTransition(sw, duration) {
            if (self.progressThumb) {
              self.progressThumb.style.transitionDuration = (duration || 0) + 'ms';
            }
          },
        },
        ...sizeCardSettings[this.cardsSize]
      };

      this.slider = new Swiper(sliderList, mainSettings);

      if (useCssMode && this.slider && this.slider.wrapperEl) {
        const w = this.slider.wrapperEl;
        w.style.overflowX = 'auto';
        w.style.overflowY = 'hidden';
        w.style.scrollSnapType = 'none';
        w.style.webkitOverflowScrolling = 'touch';
        w.style.scrollbarWidth = 'none';
        w.style.overscrollBehaviorX = 'contain';
        w.addEventListener('scroll', function () { self.schedulePosition(self.slider); }, { passive: true });
      }
    }

    measureProgress(swArg) {
      const sw = (swArg && swArg.virtualSize !== undefined) ? swArg : this.slider;
      if (!this.progressThumb || !this.progressTrack || !sw) return;

      const viewport = sw.width || this.progressTrack.clientWidth || 0;
      const total = sw.virtualSize || 0;
      this.trackWidth = this.progressTrack.clientWidth || 0;

      if (!total || total <= viewport + 1) {
        this.scrollable = false;
        this.progressTrack.style.opacity = '0';
        return;
      }

      this.scrollable = true;
      this.progressTrack.style.opacity = '1';

      const frac = Math.max(0.12, Math.min(1, viewport / total));
      this.thumbWidth = this.trackWidth * frac;
      this.progressThumb.style.width = (frac * 100) + '%';
    }

    schedulePosition(sw) {
      if (this._rafPending) return;
      this._rafPending = true;
      const swiper = sw || this.slider;
      requestAnimationFrame(() => {
        this._rafPending = false;
        this.positionProgress(swiper);
      });
    }

    positionProgress(sw) {
      if (!this.scrollable || !this.progressThumb) return;
      const swiper = sw || this.slider;
      if (!swiper) return;
      const p = Math.min(1, Math.max(0, swiper.progress || 0));
      const x = p * (this.trackWidth - this.thumbWidth);
      this.progressThumb.style.transform = 'translate3d(' + x + 'px, 0, 0)';
    }

    toggleSliderHandler() {
      if (!this.shouldDestroyOnDesktop) return;
      try {
        this.toggleSlider(window.innerWidth >= this.breakpoints.desktop);
      } catch(e) {}
    }

    toggleSlider(destroy) {
      if (destroy) {
        this.slider.destroy(true, true);
      } else {
        this.slider = new Swiper(this.querySelector('.links-with-image__slider'), this.slider.params);
      }
    }

  }

  customElements.define('tiles-slider', TilesSlider);
})();
